import {
  getTextResponsesRequest,
  getTextResponsesResponse,
} from '@core-api/presentation/presentation/interactive-content/{interactive_content_id}/text-responses';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchTextResponsesParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults?: boolean;
  sessionId: number | undefined;
}

export const useFetchTextResponses = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults = true,
  sessionId,
}: UseFetchTextResponsesParams) => {
  const requestParams = { interactiveContentId };
  const cacheKey = adminKey
    ? getFetchResultsCacheKey('text-responses', adminKey, sessionId)
    : null;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldFetchResults,
    sessionId,
    getRequest: getTextResponsesRequest,
    getResponse: getTextResponsesResponse,
  });
};
